var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDownAlt2 = function SvgArrowDownAlt2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.517 8.138 4.17 5.827a.404.404 0 0 0 .326.168h.001a.404.404 0 0 0 .328-.17l4.142-5.827a.402.402 0 0 0-.329-.635h-1.95l.001-5.234a.403.403 0 0 0-.402-.402H6.197a.402.402 0 0 0-.403.403V7.5h-1.95a.404.404 0 0 0-.327.637Z",
    fill: "#fff"
  })));
};
export default SvgArrowDownAlt2;